import { Injectable } from '@angular/core';
import { ReplaySubject } from "rxjs";


/**
 * Service for VirtualKeyboard component.
 *
 * @export
 * @class IonVirtualKeyboardService
 */
@Injectable()
export class IonVirtualKeyboardService {
  public shift$: ReplaySubject<boolean> = new ReplaySubject(1);
  public capsLock$: ReplaySubject<boolean> = new ReplaySubject(1);
  public caretPosition$: ReplaySubject<number> = new ReplaySubject(1);

  private capsLock = false;
  private shift = false;

  /**
   * Setter for Shift value, note that this also sets CapsLock value.
   *
   * @param {boolean} value
   */
  public setShift(value: boolean) {
    this.shift = value;
    this.shift$.next(this.shift);

    this.setCapsLock(this.shift);
  }

  /**
   * Setter for CapsLock value
   *
   * @param {boolean} value
   */
  public setCapsLock(value: boolean) {
    this.capsLock = value;
    this.capsLock$.next(value,);
  }

  /**
   * Toggle for Shift, note that this also toggles CapsLock
   */
  public toggleShift(): void {
    this.shift = !this.shift;
    this.shift$.next(this.shift);

    this.setCapsLock(this.shift);
  }

  /**
   * Toggle for CapsLock
   */
  public toggleCapsLock() {
    this.capsLock = !this.capsLock;
    this.capsLock$.next(this.capsLock);
  }

  /**
   * Setter for caret position value.
   *
   * @param {number}  position
   */
  public setCaretPosition(position: number) {
    this.caretPosition$.next(position);
  }

  /**
   * Method to reset Shift and CapsLock values to default ones.
   */
  public reset() {
    this.setShift(false);
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/ion-virtual-keyboard/ion-virtual-keyboard.service.ts